/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './paediatric-params.reducer';

export const PaediatricParams = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const paediatricParamsList = useAppSelector(state => state.paediatricParams.entities);
  const loading = useAppSelector(state => state.paediatricParams.loading);
  const totalItems = useAppSelector(state => state.paediatricParams.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="paediatric-params-heading" data-cy="PaediatricParamsHeading">
        <Translate contentKey="tinyMedicRestApp.paediatricParams.home.title">Paediatric Params</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.paediatricParams.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/paediatric-params/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.paediatricParams.home.createLabel">Create new Paediatric Params</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.paediatricParams.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {paediatricParamsList && paediatricParamsList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.paediatricParams.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('headCircumference')}>
                  <Translate contentKey="tinyMedicRestApp.paediatricParams.headCircumference">Head Circumference</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('headCircumference')} />
                </th>
                <th className="hand" onClick={sort('midArmCircumference')}>
                  <Translate contentKey="tinyMedicRestApp.paediatricParams.midArmCircumference">Mid Arm Circumference</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('midArmCircumference')} />
                </th>
                <th className="hand" onClick={sort('thumbGirth')}>
                  <Translate contentKey="tinyMedicRestApp.paediatricParams.thumbGirth">Thumb Girth</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('thumbGirth')} />
                </th>
                <th className="hand" onClick={sort('thumbLength')}>
                  <Translate contentKey="tinyMedicRestApp.paediatricParams.thumbLength">Thumb Length</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('thumbLength')} />
                </th>
                <th className="hand" onClick={sort('thumbNailWidth')}>
                  <Translate contentKey="tinyMedicRestApp.paediatricParams.thumbNailWidth">Thumb Nail Width</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('thumbNailWidth')} />
                </th>
                <th className="hand" onClick={sort('subscapularSkinfold')}>
                  <Translate contentKey="tinyMedicRestApp.paediatricParams.subscapularSkinfold">Subscapular Skinfold</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('subscapularSkinfold')} />
                </th>
                <th className="hand" onClick={sort('tricepsSkinfold')}>
                  <Translate contentKey="tinyMedicRestApp.paediatricParams.tricepsSkinfold">Triceps Skinfold</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('tricepsSkinfold')} />
                </th>
                <th className="hand" onClick={sort('notes')}>
                  <Translate contentKey="tinyMedicRestApp.paediatricParams.notes">Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('notes')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.paediatricParams.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.paediatricParams.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.paediatricParams.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.paediatricParams.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.paediatricParams.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.paediatricParams.weight">Weight</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.paediatricParams.patient">Patient</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {paediatricParamsList.map((paediatricParams, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/paediatric-params/${paediatricParams.id}`} color="link" size="sm">
                      {paediatricParams.id}
                    </Button>
                  </td>
                  <td>{paediatricParams.headCircumference}</td>
                  <td>{paediatricParams.midArmCircumference}</td>
                  <td>{paediatricParams.thumbGirth}</td>
                  <td>{paediatricParams.thumbLength}</td>
                  <td>{paediatricParams.thumbNailWidth}</td>
                  <td>{paediatricParams.subscapularSkinfold}</td>
                  <td>{paediatricParams.tricepsSkinfold}</td>
                  <td>{paediatricParams.notes}</td>
                  <td>{paediatricParams.active ? 'true' : 'false'}</td>
                  <td>{paediatricParams.timestampentry}</td>
                  <td>{paediatricParams.microSec}</td>
                  <td>{paediatricParams.lastupdated}</td>
                  <td>{paediatricParams.cursor}</td>
                  <td>
                    {paediatricParams.weight ? <Link to={`/weight/${paediatricParams.weight.id}`}>{paediatricParams.weight.id}</Link> : ''}
                  </td>
                  <td>
                    {paediatricParams.patient ? (
                      <Link to={`/gluco-user/${paediatricParams.patient.id}`}>{paediatricParams.patient.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/paediatric-params/${paediatricParams.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/paediatric-params/${paediatricParams.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/paediatric-params/${paediatricParams.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.paediatricParams.home.notFound">No Paediatric Params found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={paediatricParamsList && paediatricParamsList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PaediatricParams;
